var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	44914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	86672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	12843: () => (loadStrictVersion("default", "clsx", false, [1,2,1,1], () => (__webpack_require__.e(8919).then(() => (() => (__webpack_require__(28919))))))),
	98212: () => (loadStrictVersion("default", "graphql", false, [1,16,8,1], () => (__webpack_require__.e(2784).then(() => (() => (__webpack_require__(72784))))))),
	21079: () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))))),
	39689: () => (loadStrictVersion("default", "zustand", false, [1,4,3,6], () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(4085)]).then(() => (() => (__webpack_require__(34085))))))),
	95922: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,1], () => (__webpack_require__.e(5468).then(() => (() => (__webpack_require__(35468))))))),
	97897: () => (loadStrictVersion("default", "@apollo/client", false, [1,3,8,5], () => (Promise.all([__webpack_require__.e(6372), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(36372))))))),
	551: () => (loadStrictVersion("default", "lottie-react", false, [1,2,4,1], () => (__webpack_require__.e(8051).then(() => (() => (__webpack_require__(18051))))))),
	3222: () => (loadStrictVersion("default", "axios", false, [1,1,3,5], () => (__webpack_require__.e(1914).then(() => (() => (__webpack_require__(31914))))))),
	9514: () => (loadSingletonVersion("default", "react-router-dom", false, [1,6,15,0], () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(92648))))))),
	16492: () => (loadStrictVersion("default", "react-toastify", false, [1,11,1,0], () => (__webpack_require__.e(4508).then(() => (() => (__webpack_require__(74508))))))),
	17275: () => (loadStrictVersion("default", "@tanstack/match-sorter-utils", false, [1,8,8,4], () => (__webpack_require__.e(6022).then(() => (() => (__webpack_require__(46022))))))),
	18330: () => (loadStrictVersion("default", "react-redux", false, [1,8,1,3], () => (__webpack_require__.e(9733).then(() => (() => (__webpack_require__(69733))))))),
	27360: () => (loadStrictVersion("default", "@radix-ui/react-toast", false, [1,1,2,15], () => (__webpack_require__.e(3530).then(() => (() => (__webpack_require__(13530))))))),
	37112: () => (loadStrictVersion("default", "react-helmet", false, [1,6,1,0], () => (__webpack_require__.e(8154).then(() => (() => (__webpack_require__(68154))))))),
	50120: () => (loadStrictVersion("default", "framer-motion", false, [4,12,26,2], () => (Promise.all([__webpack_require__.e(1029), __webpack_require__.e(7671)]).then(() => (() => (__webpack_require__(31029))))))),
	58486: () => (loadStrictVersion("default", "demodatamanager", false, [3,0,0,54], () => (__webpack_require__.e(9102).then(() => (() => (__webpack_require__(59102))))))),
	66542: () => (loadStrictVersion("default", "clarity-js", false, [2,0,7,70], () => (__webpack_require__.e(1710).then(() => (() => (__webpack_require__(51710))))))),
	69197: () => (loadStrictVersion("default", "@tanstack/react-table", false, [1,8,10,3], () => (__webpack_require__.e(1072).then(() => (() => (__webpack_require__(61072))))))),
	87578: () => (loadStrictVersion("default", "antd", false, [1,5,16,0], () => (Promise.all([__webpack_require__.e(6943), __webpack_require__.e(3591), __webpack_require__.e(5414)]).then(() => (() => (__webpack_require__(45414))))))),
	95717: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,9,7], () => (Promise.all([__webpack_require__.e(2960), __webpack_require__.e(8713)]).then(() => (() => (__webpack_require__(78713))))))),
	96452: () => (loadStrictVersion("default", "lucide-react", false, [2,0,475,0], () => (__webpack_require__.e(9432).then(() => (() => (__webpack_require__(59432))))))),
	30734: () => (loadStrictVersion("default", "d3-sankey", false, [2,0,12,3], () => (__webpack_require__.e(8718).then(() => (() => (__webpack_require__(68718))))))),
	70500: () => (loadStrictVersion("default", "recharts", false, [1,2,15,4], () => (Promise.all([__webpack_require__.e(4752), __webpack_require__.e(8543), __webpack_require__.e(13), __webpack_require__.e(2843)]).then(() => (() => (__webpack_require__(60013))))))),
	64677: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(7796).then(() => (() => (__webpack_require__(77796))))))),
	53400: () => (loadStrictVersion("default", "tailwind-merge", false, [1,3,3,1], () => (__webpack_require__.e(7142).then(() => (() => (__webpack_require__(47142))))))),
	17671: () => (loadStrictVersion("default", "@emotion/is-prop-valid", false, [1,1,4,0], () => (__webpack_require__.e(4288).then(() => (() => (__webpack_require__(91907))))))),
	262: () => (loadStrictVersion("default", "react-redux", false, [1,8,1,3], () => (__webpack_require__.e(4025).then(() => (() => (__webpack_require__(14025))))))),
	61912: () => (loadStrictVersion("default", "chart.js", false, [1,4,4,8], () => (__webpack_require__.e(9903).then(() => (() => (__webpack_require__(49903))))))),
	75055: () => (loadStrictVersion("default", "maplibre-gl", false, [1,5,24,0], () => (__webpack_require__.e(6428).then(() => (() => (__webpack_require__(66428))))))),
	95878: () => (loadStrictVersion("default", "@faker-js/faker", false, [1,8,1,0], () => (__webpack_require__.e(1567).then(() => (() => (__webpack_require__(71567))))))),
	73977: () => (loadStrictVersion("default", "uuid", false, [1,9,0,1], () => (__webpack_require__.e(9308).then(() => (() => (__webpack_require__(79308))))))),
	12723: () => (loadStrictVersion("default", "@react-jvectormap/core", false, [1,1,0,4], () => (__webpack_require__.e(6139).then(() => (() => (__webpack_require__(56139))))))),
	93022: () => (loadStrictVersion("default", "@react-jvectormap/world", false, [1,1,1,2], () => (__webpack_require__.e(3088).then(() => (() => (__webpack_require__(63088))))))),
	12336: () => (loadStrictVersion("default", "@nivo/heatmap", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(4752), __webpack_require__.e(5929), __webpack_require__.e(8543), __webpack_require__.e(7870), __webpack_require__.e(4815)]).then(() => (() => (__webpack_require__(14815))))))),
	14067: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(6694), __webpack_require__.e(8381)]).then(() => (() => (__webpack_require__(18381))))))),
	70811: () => (loadStrictVersion("default", "remark-gfm", false, [1,4,0,0], () => (Promise.all([__webpack_require__.e(6694), __webpack_require__.e(5405)]).then(() => (() => (__webpack_require__(5405))))))),
	15941: () => (loadStrictVersion("default", "tailwind-merge", false, [1,3,3,1], () => (__webpack_require__.e(5243).then(() => (() => (__webpack_require__(65243))))))),
	88106: () => (loadStrictVersion("default", "@lottiefiles/dotlottie-react", false, [2,0,18,8], () => (__webpack_require__.e(3104).then(() => (() => (__webpack_require__(3104))))))),
	39231: () => (loadStrictVersion("default", "driver.js", false, [1,1,4,0], () => (__webpack_require__.e(9741).then(() => (() => (__webpack_require__(69741))))))),
	68859: () => (loadStrictVersion("default", "@iconify-icon/react", false, [1,2,0,1], () => (__webpack_require__.e(7675).then(() => (() => (__webpack_require__(17675))))))),
	29030: () => (loadStrictVersion("default", "react-select", false, [1,5,10,1], () => (Promise.all([__webpack_require__.e(4346), __webpack_require__.e(1760), __webpack_require__.e(6005)]).then(() => (() => (__webpack_require__(46005))))))),
	56333: () => (loadStrictVersion("default", "country-to-iso", false, [1,1,6,1], () => (__webpack_require__.e(6857).then(() => (() => (__webpack_require__(6857))))))),
	32325: () => (loadStrictVersion("default", "react-beautiful-dnd", false, [1,13,1,1], () => (Promise.all([__webpack_require__.e(2960), __webpack_require__.e(9931), __webpack_require__.e(262)]).then(() => (() => (__webpack_require__(39931))))))),
	76788: () => (loadStrictVersion("default", "react-google-charts", false, [1,5,2,1], () => (__webpack_require__.e(7747).then(() => (() => (__webpack_require__(57747))))))),
	80976: () => (loadStrictVersion("default", "regression", false, [1,2,0,1], () => (__webpack_require__.e(5312).then(() => (() => (__webpack_require__(75312))))))),
	10886: () => (loadStrictVersion("default", "@tremor/react", false, [1,3,13,1], () => (Promise.all([__webpack_require__.e(4346), __webpack_require__.e(5123), __webpack_require__.e(3400)]).then(() => (() => (__webpack_require__(75123))))))),
	28517: () => (loadStrictVersion("default", "react-grid-layout", false, [1,1,5,0], () => (Promise.all([__webpack_require__.e(3591), __webpack_require__.e(6816)]).then(() => (() => (__webpack_require__(66816))))))),
	9705: () => (loadStrictVersion("default", "jszip", false, [1,3,10,1], () => (__webpack_require__.e(9329).then(() => (() => (__webpack_require__(71710))))))),
	2811: () => (loadStrictVersion("default", "@nivo/bar", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(4752), __webpack_require__.e(5929), __webpack_require__.e(8543), __webpack_require__.e(7870), __webpack_require__.e(2912)]).then(() => (() => (__webpack_require__(72912))))))),
	64483: () => (loadStrictVersion("default", "react-syntax-highlighter", false, [1,15,6,1], () => (__webpack_require__.e(8200).then(() => (() => (__webpack_require__(78200))))))),
	13521: () => (loadStrictVersion("default", "react-json-view-lite", false, [1,1,2,1], () => (__webpack_require__.e(6400).then(() => (() => (__webpack_require__(56400))))))),
	57213: () => (loadStrictVersion("default", "react-confetti", false, [1,6,2,2], () => (__webpack_require__.e(3023).then(() => (() => (__webpack_require__(23023))))))),
	52571: () => (loadStrictVersion("default", "@google/genai", false, [1,1,31,0], () => (__webpack_require__.e(3795).then(() => (() => (__webpack_require__(76176))))))),
	70855: () => (loadStrictVersion("default", "@nivo/sankey", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(4752), __webpack_require__.e(5929), __webpack_require__.e(9699), __webpack_require__.e(734)]).then(() => (() => (__webpack_require__(99699))))))),
	8056: () => (loadStrictVersion("default", "jwt-decode", false, [1,4,0,0], () => (__webpack_require__.e(8512).then(() => (() => (__webpack_require__(68512))))))),
	73851: () => (loadStrictVersion("default", "react-chartjs-2", false, [1,5,3,1], () => (__webpack_require__.e(6734).then(() => (() => (__webpack_require__(46734)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"262": [
		262
	],
	"500": [
		70500
	],
	"734": [
		30734
	],
	"947": [
		10886
	],
	"976": [
		80976
	],
	"1912": [
		61912
	],
	"2546": [
		39231
	],
	"2571": [
		52571
	],
	"2843": [
		12843
	],
	"3003": [
		68859
	],
	"3388": [
		8056
	],
	"3400": [
		53400
	],
	"3964": [
		12723,
		93022
	],
	"3977": [
		73977
	],
	"4248": [
		88106
	],
	"4483": [
		64483
	],
	"4677": [
		64677
	],
	"4914": [
		44914
	],
	"5330": [
		70855
	],
	"5831": [
		98212
	],
	"5855": [
		76788
	],
	"5873": [
		13521
	],
	"5878": [
		95878
	],
	"5941": [
		15941
	],
	"6176": [
		12336
	],
	"6302": [
		551,
		3222,
		9514,
		16492,
		17275,
		18330,
		27360,
		37112,
		50120,
		58486,
		66542,
		69197,
		87578,
		95717,
		96452
	],
	"6333": [
		56333
	],
	"6672": [
		86672
	],
	"6915": [
		2811
	],
	"7096": [
		57213
	],
	"7671": [
		17671
	],
	"8275": [
		75055
	],
	"8304": [
		73851
	],
	"8362": [
		29030
	],
	"9552": [
		21079,
		39689,
		95922,
		97897
	],
	"9629": [
		28517
	],
	"9705": [
		9705
	],
	"9930": [
		32325
	],
	"9945": [
		14067,
		70811
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}